/**
 * Centralised API path prefixes shared across the {@code api/} clients,
 * the MSW mocks, and any other in-repo consumer that needs to refer to a
 * backend route. Only path prefixes live here -- the host portion (port /
 * scheme) lives in {@link ./config.ts API_BASE_URL} so deploy-time
 * environment variables stay in one place.
 *
 * <p>Tests deliberately do NOT import these constants -- assertions
 * about a network call SHOULD pin the literal expected URL so an
 * accidental change to a constant trips a red test instead of silently
 * shifting traffic to a different endpoint.</p>
 */

/**
 * Path prefix for the Processes domain (gallery, graph editor, runs,
 * artifacts, templates, node-definition catalog). Mirrors the backend's
 * {@code @RequestMapping("/api/v1/processes")} on
 * {@code ProcessController} / {@code ProcessRunController}.
 */
export const PROCESSES_API = '/api/v1/processes' as const;

/**
 * Path prefix for Apps (catalogue and runs). Mirrors the backend's
 * {@code @RequestMapping("/api/v1/apps")} on {@code AppCatalogController} /
 * {@code AppRunController}.
 */
export const APPS_API = '/api/v1/apps' as const;

/**
 * Path prefix for the App Builder (user-authored apps). Mirrors the backend's
 * {@code @RequestMapping("/api/v1/app-builder")} on {@code UserAppController}.
 */
export const APP_BUILDER_API = '/api/v1/app-builder' as const;

export const VIEW_RENDER_API = '/api/v1/view-render' as const;

/**
 * Path prefix for conversations. Mirrors the backend's
 * {@code @RequestMapping("/api/v1/conversations")} on
 * {@code ConversationController}.
 */
export const CONVERSATIONS_API = '/api/v1/conversations' as const;
